import { useMutation } from '@tanstack/react-query';
import { verifyEmail } from 'api';
import { toastEmitter } from 'components/Toast';

export default function useVerifyEmail({
  onSuccessFn = () => null,
  onErrorFn = () => null,
} = {}) {
  const Request = useMutation({
    mutationFn: verifyEmail,
    mutationKey: ['verifyEmail'],
    onSuccess: (data) => {
      const status = data?.status;
      const responseData = data?.data;

      if (status !== 200) {
        onErrorFn();
        return toastEmitter('error', responseData?.error?.message);
      }
      onSuccessFn();
    },
  });
  return { ...Request };
}
